import { Component, Input } from '@angular/core';
import { ModalController } from '@ionic/angular';
import { MOBILE_SCREEN_UTILS } from '@monorepo/ui';

export type TConfirmationModalComponentProps = {
  header: string;
  contentTxts?: string[];
  moreInfo?: string;
  primaryBtnTxt?: string;
  closeModalBtnTxt?: string;
  isMobile?: boolean;
  showClose?: boolean;
  headerColor?: string;
  additionalInfo?: TConfirmationAdditionalInfo;
  additionalInfoReadonly?: boolean;
  additionalInfoText?: string;
};

export type TConfirmationAdditionalInfo = {
  label?: string;
  isMandatory?: boolean;
  maxLength?: number;
  showError?: boolean;
};

export type TConfirmationModalDimissEmitVal =
  | {
      role: 'CLOSE';
      data: 'CANCELLED';
    }
  | {
      role: 'SAVE';
      data?: { additionalInfo: string };
    };

@Component({
  selector: 'monorepo-confirmation-modal',
  templateUrl: './confirmation-modal.component.html',
  styleUrls: ['./confirmation-modal.component.scss'],
})
export class ConfirmationModalComponent {
  @Input() header = '';
  @Input() contentTxts: string[] = [];
  @Input() moreInfo?: string;
  @Input() primaryBtnTxt = 'confirmation_modal.Save';
  @Input() closeModalBtnTxt = 'confirmation_modal.Close';
  @Input() headerColor = '';
  @Input() showClose = true;
  @Input() additionalInfo?: TConfirmationAdditionalInfo;
  @Input() additionalInfoReadonly = false;

  @Input() additionalInfoText = '';

  //component related data
  @Input() isMobile = false;

  constructor(private modalCtrl: ModalController) {
    this.isMobile = MOBILE_SCREEN_UTILS.isMobileScreen();
  }

  dismissModal() {
    this.modalCtrl.dismiss('CANCELLED', 'CLOSE');
  }

  onConfirm() {
    if (this.additionalInfo) {
      if (this.additionalInfo.isMandatory && !this.additionalInfoText.length) {
        this.additionalInfo = { ...this.additionalInfo, showError: true };
      } else {
        const data = {
          additionalInfo: this.additionalInfoText,
        };
        this.modalCtrl.dismiss(data, 'SAVE');
      }
    } else {
      this.modalCtrl.dismiss(undefined, 'SAVE');
    }
  }
}
